export default class Service {
  private readonly _type: string;
  private readonly _value?: string;
  private readonly _name?: string;
  private readonly _details?: object;

  constructor({
      type,
      name,
      value,
      details
  }) {
    this._type = type;
    this._value = value;
    this._name = name;
    this._details = details;
  }

  get type(): string {
    return this._type;
  }

  get name(): string|undefined {
    return this._name ? this._name : this._value;
  }

  get details(): object|undefined {
    return this._details;
  }
}
